import { render, staticRenderFns } from "./SingleProductFeature.vue?vue&type=template&id=639c2e7a&scoped=true&"
import script from "./SingleProductFeature.vue?vue&type=script&lang=js&"
export * from "./SingleProductFeature.vue?vue&type=script&lang=js&"
import style0 from "./SingleProductFeature.vue?vue&type=style&index=0&id=639c2e7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c2e7a",
  null
  
)

export default component.exports